import { useRouter } from 'found';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import HomeIcon from '@mui/icons-material/Home';
import BlockIcon from '@mui/icons-material/Block';
import PropTypes from 'prop-types';
import React, {
  Fragment,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react';
import LoadBlur from 'components/LoadBlur';
import RowSpacer from 'components/RowSpacer';
import Page from 'containers/Page';
import { Typography } from '@mui/material';

const styles = {
  cardActions: {
    display: 'flex',
  },
  cardActionButton: {
    marginRight: 0,
    minWidth: null,
  },
};

const UnsubscribePage = ({ relay, unsubscribeKey, viewer }) => {
  const { router } = useRouter();
  const [saving, setSaving] = useState(false);
  const [unsubbed, setUnsubbed] = useState(false);
  const [unsubbedFrom, setUnsubbedFrom] = useState(null);
  const [optOutable, setOptOutable] = useState(null);
  const handleDone = useCallback(
    () => router.push('/'),
    [router],
  );
  const handleUnsubscribe = useCallback(
    () => {
      setSaving(true);
      // TODO: Unsubscribe save mutation
      //  TODO: On Failure handler
      setOptOutable(null);
      setSaving(false);
      setUnsubbed(true);
      setUnsubbedFrom(null);
      //  TODO: On Success handler
      setOptOutable();
      setSaving(false);
      setUnsubbed(true);
      setUnsubbedFrom();
    },
    [
      relay,
      setOptOutable,
      setSaving,
      setUnsubbed,
      setUnsubbedFrom,
      unsubscribeKey,
    ],
  );
  const renderListBody = useCallback(
    () => (
      unsubbed
        ? (
          <CardContent>
            <Typography>
              {optOutable
                ? `You have been removed from the ${unsubbedFrom} list.`
                : ('Based on your status as a selected participant for this event, we\'re unable to unsubscribe you from this email communication.'
                + ' Please reference the pact to which you actively agreed when applying to this event.')}
              <br />
              <br />
              {optOutable
                ? ''
                : 'Congrats on being selected – we look forward to hearing about your experience!'}
            </Typography>
          </CardContent>
        )
        : (
          <CardContent>
            <Typography>
              Removing you from the list...
            </Typography>
          </CardContent>
        )
    ),
    [
      optOutable,
      unsubbed,
      unsubbedFrom,
    ],
  );
  useEffect(
    () => {
        handleUnsubscribe();
    },
    [
      handleUnsubscribe,
    ],
  );
  const trackerData = useMemo(
    () => ({
      viewer,
    }),
    [
      viewer,
    ],
  );
  return (
    <Page
      title='Unsubscribe'
      trackerData={trackerData}
      viewer={viewer}
    >
      <LoadBlur loading={saving}>
        {renderListBody()}
        <CardActions style={styles.cardActions}>
          <RowSpacer />
          {unsubbed
            ? (
              <Fragment>
                <Button
                  startIcon={<HomeIcon />}
                  onClick={handleDone}
                  primary
                  style={styles.cardActionButton}
                >
                  Home
                </Button>
              </Fragment>
            )
            : (
              <Button
                startIcon={<BlockIcon />}
                onClick={handleUnsubscribe}
                primary
                style={styles.cardActionButton}
              >
                Unsubscribe From List
              </Button>
            )}
        </CardActions>
      </LoadBlur>
    </Page>
  );
};

UnsubscribePage.propTypes = {
  unsubscribeKey: PropTypes.string.isRequired,
  relay: PropTypes.object.isRequired,
  viewer: PropTypes.object.isRequired,
};

export default UnsubscribePage;
